import { DownloadOutlined } from "@ant-design/icons";
import { Button, Table, Tooltip, message } from "antd";
import { saveAs } from "file-saver";
import moment from "moment";
import React, { useState } from "react";
import { serverUrl } from "../../../../../nestserver";

const ViewTransactionHistory = ({ transactionHistory, studentId }) => {
  const [downloading, setDownloading] = useState({});

  const handleReceiptDownload = async (record) => {
    const txnId = record?._id;
    const sfId = record?.student_fee || studentId;
    if (!txnId) return;
    setDownloading((prev) => ({ ...prev, [txnId]: true }));
    try {
      const res = await fetch(
        `${serverUrl}/admin/student-fee/${sfId}/transaction/${txnId}/download`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
          },
        },
      );
      if (!res.ok) throw new Error("Download failed");
      const blob = await res.blob();
      saveAs(blob, `receipt-${record?.unique_id || txnId}.pdf`);
    } catch {
      message.error("Failed to download receipt");
    } finally {
      setDownloading((prev) => ({ ...prev, [txnId]: false }));
    }
  };

  const columns = [
    {
      title: "Transaction ID",
      key: "unique_id",
      align: "center",
      render: (record) => (
        <div
          key={record?._id}
          style={{ color: "#111111" }}
          className="text-base text-center font-mono"
        >
          {record?.unique_id || "—"}
        </div>
      ),
    },
    {
      title: "Fee Type",
      key: "feeType",
      align: "center",
      render: (record) => {
        const isMisc = record?.feeCategory === "other";
        const raw = isMisc ? "other" : (record?.feeTemplateType || "");
        const label =
          raw.toLowerCase() === "other"
            ? "Miscellaneous"
            : raw.toLowerCase() === "tution" || raw.toLowerCase() === "tuition"
            ? "Tuition"
            : raw.toLowerCase() === "transportation"
            ? "Transportation"
            : raw.toLowerCase() === "accommodation"
            ? "Accommodation"
            : raw.toLowerCase() === "daycare"
            ? "Day Care"
            : raw || "--";
        return (
          <div
            key={record?._id}
            style={{ color: "#111111" }}
            className="text-base font-semibold text-center"
          >
            {label}
          </div>
        );
      },
    },
    {
      title: "Paid Date",
      dataIndex: "",
      key: "",
      align: "center",
      render: (record) => (
        <div
          key={record?._id}
          style={{ color: "#111111" }}
          className="text-base  text-center"
        >
          {record?.date
            ? moment(record?.date).format("DD-MMM-YYYY")
            : record?.fee_details?.last_paid
              ? moment(record?.fee_details?.last_paid).format("DD-MMM-YYYY")
              : "—"}
        </div>
      ),
    },
    // {
    //   title: "Total Fee",
    //   dataIndex: "",
    //   key: "",
    //   align: "center",
    //   render: (record) => (
    //     <div
    //       key={record?._id}
    //       style={{ color: "#111111" }}
    //       className="text-base text-center"
    //     >
    //       {record?.total_fee ?? "—"}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Total Paid",
    //   dataIndex: [],
    //   key: "",
    //   render: (record) => (
    //     <div style={{ color: "#616161" }} className=" text-base">
    //       {record?.total_paid ?? "—"}
    //     </div>
    //   ),
    // },
    {
      title: "Current Payment",
      dataIndex: [],
      key: "",
      render: (record) => (
        <div style={{ color: "#616161" }} className=" text-base">
          {record?.amount ?? "—"}
        </div>
      ),
    },
    // {
    //   title: "Total Remaining",
    //   dataIndex: [],
    //   key: "",
    //   render: (record) => (
    //     <div style={{ color: "#616161" }} className=" text-base">
    //       {record?.total_remaining ?? "—"}
    //     </div>
    //   ),
    // },
    {
      title: "Type",
      dataIndex: [],
      key: "",
      render: (record) => (
        <div style={{ color: "#616161" }} className=" text-base capitalize">
          {record?.type || "—"}
        </div>
      ),
    },
    {
      title: "Added By",
      dataIndex: [],
      key: "",
      align: "center",
      render: (record) => {
        const addedBy = record?.added_by;
        const label = addedBy?.first_name
          ? `${addedBy.first_name} ${addedBy.last_name || ""}`.trim()
          : "Online Payment";
        return (
          <div
            style={{
              color: addedBy?.first_name ? "#111111" : "#1890ff",
              fontStyle: addedBy?.first_name ? "normal" : "italic",
            }}
            className="text-base text-center capitalize"
          >
            {label}
          </div>
        );
      },
    },
    {
      title: "Due Date",
      dataIndex: [],
      key: "",
      align: "center",
      render: (record) => (
        <div
          key={record?._id}
          style={{ color: "#111111" }}
          className=" text-base text-center capitalize"
        >
          {record?.due_date
            ? moment(record?.due_date).format("DD-MMM-YYYY")
            : "—"}
        </div>
      ),
    },
    {
      title: "Receipt",
      dataIndex: [],
      key: "receipt",
      align: "center",
      render: (record) =>
        record?.status === 'approved' ? (
          <Tooltip title="Download Receipt">
            <Button
              type="text"
              icon={<DownloadOutlined />}
              loading={!!downloading[record?._id]}
              onClick={() => handleReceiptDownload(record)}
            />
          </Tooltip>
        ) : (
          <span className="text-gray-400 text-sm">—</span>
        ),
    },
  ];

  // Calculate overall summary
  const totalFee =
    transactionHistory?.reduce(
      (acc, curr) => acc + (curr?.transactions?.[0]?.total_fee || 0),
      0,
    ) || 0;
  const totalPaid =
    transactionHistory?.reduce(
      (acc, curr) => acc + (curr?.transactions?.[0]?.total_paid || 0),
      0,
    ) || 0;
  return (
    <>
      <div className="">
        <h3 className="text-xl font-bold pb-4">Transaction History</h3>
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className=" bg-white drop-shadow-md w-full "
        >
          <div className="py-5">
            {transactionHistory &&
              transactionHistory?.length > 0 &&
              transactionHistory?.map((group, index) => (
                <div key={index} style={{ marginBottom: "50px" }}>
                  <div className="px-6 py-3 bg-gray-50 border-y border-gray-100 mb-4">
                    <h4 className="text-base font-bold text-gray-700 capitalize">
                      {group?.feeTemplate?.type?.toLowerCase() === "tution" ? "Tuition" : group?.feeTemplate?.type?.toLowerCase() === "daycare" ? "Day Care" : group?.feeTemplate?.type} Fee Records
                    </h4>
                  </div>
                  <Table
                    columns={columns}
                    dataSource={
                      group && group?.transactions?.length > 0
                        ? group?.transactions?.sort((a, b) =>
                            moment(a?.createdAt).isBefore(b?.createdAt)
                              ? 1
                              : -1,
                          )
                        : []
                    }
                    pagination={false}
                    loading={group?.isLoading}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewTransactionHistory;
